var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { commonService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from "~/core/decorator";
import { Service } from "~/core/service";
var WebSocketMsgService = /** @class */ (function (_super) {
    __extends(WebSocketMsgService, _super);
    function WebSocketMsgService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 获取消息列表
     * @param data 查询参数实体
     * @param page 分页参数
     * @param sort 排序参数
     */
    WebSocketMsgService.prototype.getMsgList = function (data, page, sort, loading) {
        return this.netService.send({
            server: commonService.webSocketMsgController.getMsgList,
            data: data,
            page: page,
            sort: sort,
            loading: loading
        });
    };
    /**
     * 获取未读消息总数
     */
    WebSocketMsgService.prototype.getUnReadMsgCount = function (loading) {
        return this.netService.send({
            server: commonService.webSocketMsgController.getUnReadMsgCount,
            loading: loading
        });
    };
    /**
     * 删除消息
     */
    WebSocketMsgService.prototype.updateMsgStatus = function (ids, loading) {
        return this.netService.send({
            server: commonService.webSocketMsgController.updateMsgStatus,
            data: {
                ids: ids
            },
            loading: loading
        });
    };
    /**
     * 获取消息详情
     * @param data 消息id列表
     * @param loading 加载等待
     */
    WebSocketMsgService.prototype.getMsgDetail = function (id, loading) {
        return this.netService.send({
            server: commonService.webSocketMsgController.getMsgDetail,
            data: id,
            loading: loading
        });
    };
    /**
     * 获取最新三条未读消息
     * @param loading 加载等待
     */
    WebSocketMsgService.prototype.getWorkbenchReminder = function (loading) {
        return this.netService.send({
            server: commonService.webSocketMsgController.getWorkbenchReminder,
            loading: loading
        });
    };
    /**
     * 根据Id列表批量删除消息
     * @param data 实体
     * @param loading 加载等待
     */
    WebSocketMsgService.prototype.deletedReminderMessage = function (data, loading) {
        return this.netService.send({
            server: commonService.webSocketMsgController.deletedReminderMessage,
            data: { idList: data },
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], WebSocketMsgService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], WebSocketMsgService.prototype, "updateMsgStatus", null);
    return WebSocketMsgService;
}(Service));
export { WebSocketMsgService };
